import { render, staticRenderFns } from "./report_stu_after.vue?vue&type=template&id=6ce687db&scoped=true&"
import script from "./report_stu_after.vue?vue&type=script&lang=js&"
export * from "./report_stu_after.vue?vue&type=script&lang=js&"
import style0 from "./report_stu_after.vue?vue&type=style&index=0&id=6ce687db&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce687db",
  null
  
)

export default component.exports